import ClientAddresses from "./ClientAddresses";
export default ClientAddresses;